const TypeEvent = {
  LIVE: 0,
  LIVESHOW: 1,
  VOD: 2,
  TOPIC: 3,
  LEAGUE: 4,
  STORY: 5,
  BANNER: 6,
  CHANNEL: 7,
  SERVICE: 8,
  RESUME: 9
}
export default TypeEvent
